module.exports = __webpack_public_path__ + "images/category_lp/common/reason2-watch@2x_fc1f9db1b66bdad9887af7a514702ca0.jpg";